export default "__VITE_ASSET__DQZeyQRF__"